// src/components/profile/OrgInfo.jsx
import React from "react";

export default function OrgInfo({ org }) {
  return (
    <div className="border-t border-b px-5 py-4">
      <h3 className="font-medium mb-3">조직</h3>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <div className="text-xs text-gray-500 mb-1">회사</div>
          <div className="rounded-md border px-3 py-2 bg-gray-50">
            {org.company_name || "-"}
          </div>
        </div>
        <div>
          <div className="text-xs text-gray-500 mb-1">부서</div>
          <div className="rounded-md border px-3 py-2 bg-gray-50">
            {org.department_name || "-"}
          </div>
        </div>
        <div>
          <div className="text-xs text-gray-500 mb-1">직위</div>
          <div className="rounded-md border px-3 py-2 bg-gray-50">
            {org.position_name || "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
